import { getBillImage } from '../api/BillsService';
import ImageViewer from '../components/common/ImageViewer';

export default function BillImage() {
  return <ImageViewer fetchImageFile={getBillImage} title="Bill file" />;
}
